/**
 * Created by ShaunBetts on 14-May-16.
 */

let PortalError = function (message, code) {
  this.data = {
    type: 'PortalError',
    typeLabel: 'Error',
    message: message,
    code: code ||null,
    stack: new Error().stack.split(' at '),
    detailedError: {},
    additionalData: {},
    notifyUser: true
  };
};

PortalError.prototype = Object.create(Error.prototype);

PortalError.prototype.detailedError = function (detailedError) {
  this.data.detailedError = detailedError;
  return this;
};

PortalError.prototype.additionalData = function (data){
  this.data.additionalData = data;
  return this;
};

PortalError.prototype.hideFromUser = function (){
  this.data.notifyUser = false;
  return this;
};

PortalError.prototype.get = function (data){
  return this.data;
};

export default PortalError;